// extracted by mini-css-extract-plugin
module.exports = {"container":"article_container__6Qpok","row1":"article_row1__3CeQj"};